import { render, staticRenderFns } from "./form-mail.vue?vue&type=template&id=3856d202&scoped=true&"
import script from "./form-mail.vue?vue&type=script&lang=js&"
export * from "./form-mail.vue?vue&type=script&lang=js&"
import style0 from "./form-mail.vue?vue&type=style&index=0&id=3856d202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856d202",
  null
  
)

export default component.exports